const MAX_PENDING_COLLECTION_RESTORATIONS = 20;

const pendingCollectionRestorations = new Map<string, string>();

export const hasPendingCollectionRestoration = (collectionId: string) =>
    Array.from(pendingCollectionRestorations.values()).some(
        (pendingCollectionId) => pendingCollectionId === collectionId,
    );

export const addPendingCollectionRestoration = (locationKey: string, collectionId: string) => {
    pendingCollectionRestorations.delete(locationKey);
    pendingCollectionRestorations.set(locationKey, collectionId);

    const evictedCollectionIds = new Set<string>();

    while (pendingCollectionRestorations.size > MAX_PENDING_COLLECTION_RESTORATIONS) {
        const oldestEntry = pendingCollectionRestorations.entries().next().value;

        if (!oldestEntry) {
            break;
        }

        const [oldestLocationKey, oldestCollectionId] = oldestEntry;
        pendingCollectionRestorations.delete(oldestLocationKey);

        if (!hasPendingCollectionRestoration(oldestCollectionId)) {
            evictedCollectionIds.add(oldestCollectionId);
        }
    }

    return evictedCollectionIds;
};

export const consumePendingCollectionRestoration = (locationKey: string, collectionId: string) => {
    if (pendingCollectionRestorations.get(locationKey) === collectionId) {
        pendingCollectionRestorations.delete(locationKey);
    }
};
